export default __webpack_public_path__ + "static/media/05.47df360f.jpg";